import { Component, HostListener, AfterViewInit, inject, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { ModalLayoutComponent } from "./ui/modal/modal-layout.component";
import { DropdownLayoutComponent } from "./ui/dropdown/dropdown-layout.component";
import { NotifyQueueComponent } from "./ui/notify/notify-queue.component";
import { StartService } from './start/start.service';
import { HeaderComponent } from "./ui/header/header.component";
import { ViewSwitcherComponent } from "./ui/view-switcher/view-switcher.component";
import { TranslateModule } from '@ngx-translate/core';
import { SvgIconComponent } from "./ui/svg-icon/svg-icon.component";
import { delay, Subscription, tap } from 'rxjs';
import { ThemeService } from './core/service/theme.service';
import { ActiveUserService } from './core/service/active-user.service';
import { GoogleOnetapComponent } from './auth/google-onetap/google-onetap.component';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, ModalLayoutComponent, DropdownLayoutComponent, NotifyQueueComponent, HeaderComponent, ViewSwitcherComponent, TranslateModule, SvgIconComponent, GoogleOnetapComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.css'
})
export class AppComponent implements AfterViewInit, OnDestroy {

  private cdr = inject(ChangeDetectorRef)
  private startService = inject(StartService)
  private activeUserService = inject(ActiveUserService)
  private themeService = inject(ThemeService)

  private sb = this.themeService.theme$.subscribe(theme => document.documentElement.classList.toggle('theme-dark', theme == 'dark'))
  private startModalSb?: Subscription;

  protected startModalClosed = false

  ngAfterViewInit(): void {
    this.startModalSb = this.startService.showModal().pipe(
      tap(event => {
        this.startModalClosed = !event.show;
        this.cdr.detectChanges();
      }),
      delay(3000)
    ).subscribe(() => this.startService.destroyModal())

    this.activeUserService.start()

    this.onResize()
    if ('visualViewport' in window) {
      (window as any).visualViewport.addEventListener('resize', () => this.onResize())
    }
  }

  @HostListener('window:resize')
  onResize() {
    if (window.innerWidth >= 1280) {
      const height = window.innerHeight
      document.documentElement.style.height = document.body.style.height = `${height}px`
    } else {
      document.documentElement.style.height = document.body.style.height = 'auto'
    }
  }

  ngOnDestroy() {
    this.sb.unsubscribe()
    this.startModalSb?.unsubscribe()
  }
}
